/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject,
    ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObjectFromJSON,
    ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObjectFromJSONTyped,
    ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObjectToJSON,
} from './';

/**
 * 
 * @export
 * @interface MonitoredObjectToMonitoredObject
 */
export interface MonitoredObjectToMonitoredObject {
    /**
     * 
     * @type {Date}
     * @memberof MonitoredObjectToMonitoredObject
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof MonitoredObjectToMonitoredObject
     */
    validTo?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectToMonitoredObject
     */
    pairInfo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectToMonitoredObject
     */
    unpairInfo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectToMonitoredObject
     */
    source: MonitoredObjectToMonitoredObjectSourceEnum;
    /**
     * 
     * @type {ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject}
     * @memberof MonitoredObjectToMonitoredObject
     */
    primaryMonitoredObject?: ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject;
    /**
     * 
     * @type {ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject}
     * @memberof MonitoredObjectToMonitoredObject
     */
    secondaryMonitoredObject?: ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObject;
}

export function MonitoredObjectToMonitoredObjectFromJSON(json: any): MonitoredObjectToMonitoredObject {
    return MonitoredObjectToMonitoredObjectFromJSONTyped(json, false);
}

export function MonitoredObjectToMonitoredObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredObjectToMonitoredObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'validFrom': (new Date(json['valid_from'])),
        'validTo': !exists(json, 'valid_to') ? undefined : (json['valid_to'] === null ? null : new Date(json['valid_to'])),
        'pairInfo': !exists(json, 'pair_info') ? undefined : json['pair_info'],
        'unpairInfo': !exists(json, 'unpair_info') ? undefined : json['unpair_info'],
        'source': json['source'],
        'primaryMonitoredObject': !exists(json, 'primary_monitored_object') ? undefined : ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObjectFromJSON(json['primary_monitored_object']),
        'secondaryMonitoredObject': !exists(json, 'secondary_monitored_object') ? undefined : ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObjectFromJSON(json['secondary_monitored_object']),
    };
}

export function MonitoredObjectToMonitoredObjectToJSON(value?: MonitoredObjectToMonitoredObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'valid_from': (value.validFrom.toISOString()),
        'valid_to': value.validTo === undefined ? undefined : (value.validTo === null ? null : value.validTo.toISOString()),
        'pair_info': value.pairInfo,
        'unpair_info': value.unpairInfo,
        'source': value.source,
        'primary_monitored_object': ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObjectToJSON(value.primaryMonitoredObject),
        'secondary_monitored_object': ReadOnlyMonitoredObjectToMonitoredObjectPrimaryMonitoredObjectToJSON(value.secondaryMonitoredObject),
    };
}

/**
* @export
* @enum {string}
*/
export enum MonitoredObjectToMonitoredObjectSourceEnum {
    TId = 't_id',
    Man = 'man'
}


